document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.footer-acc').forEach(function (acc) {
        var btn = acc.querySelector('.footer-acc__head');
        var panel = acc.querySelector('.footer-acc__panel');
        btn.addEventListener('click', function () {
            var open = acc.classList.toggle('is-open');
            panel.hidden = !open;
        });
    });
});